import { Button, styled } from '@mui/material';

export const CustomButton = styled(Button)`
  height: 40px;
  min-width: max-content;
`;
